import styled from "styled-components"

export default styled.span`
  text-align: right;
  float: right;
  font-size: 0.8em;
  padding: 0.5rem 0;
  opacity: 0.8;
`
